import { DOT_RANGES as c } from "./index.es2385.js";
const p = (n) => {
  const t = parseInt(n.replace("%", ""), 10), e = c.find(({ min: o, max: r }) => t >= o && t <= r);
  return e ? e.position : "12.5%";
};
export {
  p as getDotLeft
};
//# sourceMappingURL=index.es802.js.map
